<table class="powertrain_table">
  <tr [ngStyle]="{ height: '50px' }">
    <th rowspan="2">Sensor #</th>
    <th colspan="3">Triaxial Vibration (mm/s)</th>
    <th colspan="2">Temperature (C)</th>
    <th
      rowspan="2"
      [matTooltip]="get_Ultra_info()"
      [matTooltipClass]="'tooltip'"
    >
      Acoustics (dBA)
    </th>
    <th
      rowspan="2"
      [matTooltip]="get_Audible_info()"
      [matTooltipClass]="'tooltip'"
    >
      Δ Ultrasonic 
      <!-- <th rowspan="2">Leakage M. Flux (T)</th> -->
      <!-- <th colspan="3">*Optional Analog Sensor (Current/Flow/Piezo)</th> -->
    </th>
  </tr>

  <tr [ngStyle]="{ height: '40px' }">
    <th [matTooltip]="get_H_info()" [matTooltipClass]="'tooltip'">H</th>
    <th [matTooltip]="get_H_info()" [matTooltipClass]="'tooltip'">V</th>
    <th [matTooltip]="get_H_info()" [matTooltipClass]="'tooltip'">A</th>
    <th [matTooltip]="get_Temo_info()" [matTooltipClass]="'tooltip'">Skin</th>
    <th [matTooltip]="get_Temo_info()" [matTooltipClass]="'tooltip'">Core</th>
    <!-- <th>A</th> -->
    <!-- <th>B</th> -->
    <!-- <th>C</th> -->
  </tr>

  <tr *ngFor="let s of idsData" [ngStyle]="{ height: '40px' }">
    <td
      *ngIf="!s.loader"
      [ngStyle]="{ color: 'black' }"
      [ngClass]="{
        'light-green-bg': s?.color == '#72ff13',
        'light-red-bg': s?.color == '#ff2a1b',
        'light-yellow-bg': s?.color == '#faa700',
        'bg-white':s?.sensor[3]?.value=='NaN'
      }"
    >
      {{ s?.sensorDNames }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[8]?.color == 'green',
        'light-red-bg': s?.sensor[8]?.color == 'red',
        'light-yellow-bg': s?.sensor[8]?.color == 'yellow',
        'bg-white':s?.sensor[8]?.value=='NaN'
      }"
    >
      {{
        s?.sensor[8]?.value
          ? s?.sensor[8]?.value == "NaN"
            ? "NA"
            : s?.sensor[8]?.value
          : "N/A"
      }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[6]?.color == 'green',
        'light-red-bg': s?.sensor[6]?.color == 'red',
        'light-yellow-bg': s?.sensor[6]?.color == 'yellow',
        'bg-white':s?.sensor[6].value=='NaN'
      }"
    >
      {{
        s?.sensor[6]?.value
          ? s?.sensor[6]?.value == "NaN"
            ? "NA"
            : s?.sensor[6]?.value
          : "N/A"
      }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[7]?.color == 'green',
        'light-red-bg': s?.sensor[7]?.color == 'red',
        'light-yellow-bg': s?.sensor[7]?.color == 'yellow',
        'bg-white':s?.sensor[7]?.value=='NaN'
      }"
    >
      {{
        s?.sensor[7]?.value
          ? s?.sensor[7]?.value == "NaN"
            ? "NA"
            : s?.sensor[7]?.value
          : "N/A"
      }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[0]?.color == 'green',
        'light-red-bg': s?.sensor[0]?.color == 'red',
        'light-yellow-bg': s?.sensor[0]?.color == 'yellow',
        'bg-white':s?.sensor[0]?.value=='NaN'
      }"
    >
      {{
        s?.sensor[0]?.value
          ? s?.sensor[0]?.value == "NaN"
            ? "NA"
            : s?.sensor[0]?.value
          : "N/A"
      }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[3]?.color == 'green',
        'light-red-bg': s?.sensor[3]?.color == 'red',
        'light-yellow-bg': s?.sensor[3]?.color == 'yellow',
        'bg-white':s?.sensor[3]?.value=='NaN'
      }"
    >
      NA
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[13]?.color == 'green',
        'light-red-bg': s?.sensor[13]?.color == 'red',
        'light-yellow-bg': s?.sensor[13]?.color == 'yellow',
        'bg-white':s?.sensor[13]?.value=='NaN'
      }"
    >
      <!-- {{ s?.sensor[14].predicted }} -->
      {{
        s?.sensor[13]?.value
          ? s?.sensor[13]?.value == "NaN"
            ? "NA"
            : s?.sensor[13]?.value
          : "N/A"
      }}
    </td>
    <td
      *ngIf="!s.loader"
      [ngClass]="{
        'light-green-bg': s?.sensor[12]?.color == 'green',
        'light-red-bg': s?.sensor[12]?.color == 'red',
        'light-yellow-bg': s?.sensor[12]?.color == 'yellow',
        'bg-white':s?.sensor[12]?.value=='NaN'
      }"
    >
      {{ s?.sensor[14].predicted ? s?.sensor[14]?.predicted.toFixed(1) : "N/A" }}
    </td>

    <td *ngIf="s.loader" [ngStyle]="{ color: s.color }">
      {{ s?.sensor_no == "0" ? "B" : s?.sensor_no }}
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
    <td class="" *ngIf="s.loader">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </td>
  </tr>
  <tr *ngFor="let s of extraRow" [ngStyle]="{ height: '40px' }">
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
    <td class="light-gray-bg"></td>
  </tr>
</table>
